<!-- <app-main-carousel [slides]="HudsunSlides"></app-main-carousel> -->
<div class="main-slider">
    <div class="swiper-container h-100" [swiper]="HomeSliderConfig">
      <div class="swiper-wrapper h-100">      
        <div *ngFor="let slide of HudsunSlides" class="swiper-slide">
          <div class="slide-item swiper-lazy">
              <div class="swiper-lazy-preloader swiper-lazy-preloader-white"></div>
              <div class="mask"></div>  
              <div fxLayout="column" fxLayoutAlign="center center" class="content">
                <h1>{{slide.title}}</h1>
                <h2>FARM FRESH  {{dynamicContent}}</h2>
                <h3>{{slide.subtitle}}</h3>
                <button routerLink="/sign-in" class="btnSqRed hand-hover">Get Started</button>
              </div>
              <img [src]="slide.image" class="imgRes" alt="slide"> 
          </div>
        </div>
      </div>
      <!-- <div class="swiper-pagination white"></div> -->
      <button mat-mini-fab color="primary" class="swiper-button-prev swipe-arrow" aria-label="leftslide">
        <mat-icon>keyboard_arrow_left</mat-icon>
      </button>
      <button mat-mini-fab color="primary" class="swiper-button-next swipe-arrow" aria-label="rightslide"><mat-icon>keyboard_arrow_right</mat-icon></button>
    </div>
</div>
<!-- <section style="position: relative;">
    <swiper [config]="HomeSliderConfig">
        <div *ngFor="let slide of HudsunSlides">
            <img [src]="slide.image" class="imgRes">
        </div>
      </swiper>
</section> -->
<section class="ourServicesHP">
      <div class="max-1200">
          <div fxLayout="row wrap"  fxLayout.lt-sm="column" fxLayoutGap="15px" class="ty-50">
              <div fxFlex="100" fxFlex.sm="calc(50% - 15px)" fxFlex.gt-sm="calc(33% - 15px)">
                <div class="contentImg" *ngIf="!!featureTags && !featureTags['sf_cms_images']">
                    <img class="imgRes" src="https://hudsonmilk.com/images/3/cms/hm-1.jpg" alt="product">
                </div>
                  <div class="contentImg" *ngIf="!!featureTags && featureTags['sf_cms_images']">
                      <img class="imgRes" src="assets/hudson/files/images/3/content-images/hm-1.jpg" alt="product">
                  </div>
                  <div fxLayout="column" fxLayoutAlign="center center" class="ServiceDesc text-center">
                      <h5>HOW IT WORKS</h5>
                      <h6>It’s as easy as 1, 2, 3!</h6>
                      <ul class="list-unstyled">
                          <li><b>1.</b>Register</li>
                          <li><b>2.</b> Place your order</li>
                          <li><b>3.</b> One of our amazing drivers will deliver your products so you and your family can begin enjoying farm-fresh goodness!</li>
                      </ul>
                      <a href="javascript:void(0)" routerLink="/our-services" class="btnBorderRed">LEARN MORE</a>
                  </div>
              </div>
              <div fxFlex="100" fxFlex.sm="calc(50% - 15px)" fxFlex.gt-sm="calc(33% - 15px)">
                <div class="contentImg" *ngIf="!!featureTags && !featureTags['sf_cms_images']">
                    <img class="imgRes" src="https://hudsonmilk.com/images/3/cms/hm-3.jpg" alt="product">
                </div>
                  <div class="contentImg" *ngIf="!!featureTags && featureTags['sf_cms_images']">
                      <img class="imgRes" src="assets/hudson/files/images/3/content-images/hm-3.jpg" alt="product">
                  </div>
                  <div fxLayout="column" fxLayoutAlign="center center" class="ServiceDesc text-center">
                      <h5>OUR PRODUCTS</h5>
                      <p>We are committed to carrying products that are sourced from only the finest ingredients and are free from all those harmful chemicals found in conventional food. The only products we carry are those which we feel good about feeding to our own kids.</p>
                      <a href="javascript:void(0)" routerLink="/shop" class="btnBorderRed">LEARN MORE</a>
                  </div>
              </div>
              <div fxFlex="100" fxFlex.gt-sm="calc(33% - 15px)" class="my30">
                <div class="contentImg" *ngIf="!!featureTags && !featureTags['sf_cms_images']">
                    <img class="imgRes" src="https://hudsonmilk.com/images/3/cms/hm-2.jpg" alt="product">
                </div>
                  <div class="contentImg" *ngIf="!!featureTags && featureTags['sf_cms_images']">
                      <img class="imgRes" src="assets/hudson/files/images/3/content-images/hm-2.jpg" alt="product">
                  </div>
                  <div fxLayout="column" fxLayoutAlign="center center" class="ServiceDesc text-center">
                      <h5>OUR FARMS</h5>
                      <p>We partner with small, family-owned farms and businesses who share the same passion for our food system as we do. Our farmers are committed to raising their animals humanely and producing only the best food—you can taste the difference!</p>
                      <a href="javascript:void(0)" routerLink="/vendors" class="btnBorderRed">LEARN MORE</a>
                  </div>
              </div>
          </div>
      </div>
  </section>
  <section class="CHOOSEUS">
      <div class="max-1300">
          <div class="chUsContent">
              <div fxLayout="row wrap">
                <div fxFlex.lt-md="100%" fxFlex="50%" *ngIf="!!featureTags && !featureTags['sf_cms_images']">
                    <h1 class="SndTitle">WHY CHOOSE US</h1>
                    <img src="https://hudsonmilk.com/images/3/cms/hr-line.svg" alt="design">
                    <p class="PriP">Do you know where your food comes from? We do!</p>
                    <p class="PriP">By partnering with local and regional farms and businesses we are able to source only the purest, most natural products for you and your family.</p>
                    <a href="javascript:void(0)" routerLink="/shop" class="btnSqRed">SHOP OUR PRODUCTS</a>
                </div>
                  <div fxFlex.lt-md="100%" fxFlex="50%" *ngIf="!!featureTags && featureTags['sf_cms_images']">
                      <h1 class="SndTitle">WHY CHOOSE US</h1>
                      <img src="assets/hudson/files/images/3/content-images/hr-line.svg" alt="design">
                      <p class="PriP">Do you know where your food comes from? We do!</p>
                      <p class="PriP">By partnering with local and regional farms and businesses we are able to source only the purest, most natural products for you and your family.</p>
                      <a href="javascript:void(0)" routerLink="/shop" class="btnSqRed">SHOP OUR PRODUCTS</a>
                  </div>
                  <div fxFlex.lt-md="100%" fxFlex="50%">
                      <swiper [config]="Swconfig">
                          <div *ngFor="let slide of whyChooseSlides" class="whyChooseSlides">
                              <img src="{{slide}}" class="imgRes" alt="product">
                          </div>
                     </swiper>
                  </div>
              </div>
              <div fxLayout="row wrap" class="CHSer text-center" fxLayoutGap.gt-sm="30px">
                  <div fxFlex.lt-md="100%" fxFlex="calc(25% - 30px)">
                    <div class="why-choose-us-list" *ngIf="!!featureTags && !featureTags['sf_cms_images']">
                        <img src="https://hudsonmilk.com/images/3/cms/icon-shipped.svg" alt="delivery">
                        <p class="PriP">Reliable delivery right to your doorstep</p>
                    </div>
                      <div class="why-choose-us-list" *ngIf="!!featureTags && featureTags['sf_cms_images']">
                          <img src="assets/hudson/files/images/3/content-images/icon-shipped.svg" alt="delivery">
                          <p class="PriP">Reliable delivery right to your doorstep</p>
                      </div>
                  </div>
                  <div fxFlex.lt-md="100%" fxFlex="calc(25% - 30px)">
                    <div class="why-choose-us-list" *ngIf="!!featureTags && !featureTags['sf_cms_images']">
                        <img src="https://hudsonmilk.com/images/3/cms/icon-food.svg" alt="preservation">
                        <p class="PriP">Food that is free from artificial preservatives and additives</p>
                    </div>
                      <div class="why-choose-us-list" *ngIf="!!featureTags && featureTags['sf_cms_images']">
                          <img src="assets/hudson/files/images/3/content-images/icon-food.svg" alt="preservation">
                          <p class="PriP">Food that is free from artificial preservatives and additives</p>
                      </div>
                  </div>
                  <div fxFlex.lt-md="100%" fxFlex="calc(25% - 30px)">
                    <div class="why-choose-us-list" *ngIf="!!featureTags && !featureTags['sf_cms_images']">
                        <img src="https://hudsonmilk.com/images/3/cms/icon-local.svg" alt="ecofriendly">
                        <p class="PriP">Supporting local, family-owned farms and businesses</p>
                    </div>
                      <div class="why-choose-us-list" *ngIf="!!featureTags && featureTags['sf_cms_images']">
                          <img src="assets/hudson/files/images/3/content-images/icon-local.svg" alt="ecofriendly">
                          <p class="PriP">Supporting local, family-owned farms and businesses</p>
                      </div>
                  </div>
                  <div fxFlex.lt-md="100%" fxFlex="calc(25% - 30px)">
                    <div class="why-choose-us-list" *ngIf="!!featureTags && !featureTags['sf_cms_images']">
                        <img src="https://hudsonmilk.com/images/3/cms/icon-dairy.svg" alt="glassbottle">
                        <p class="PriP">Glass bottled milk and a whole lot more!</p>
                    </div>
                      <div class="why-choose-us-list" *ngIf="!!featureTags && featureTags['sf_cms_images']">
                          <img src="assets/hudson/files/images/3/content-images/icon-dairy.svg" alt="glassbottle">
                          <p class="PriP">Glass bottled milk and a whole lot more!</p>
                      </div>
                  </div>
              </div>
          </div>
      </div>
  </section>
  <section class="btnContent">
    <div class="max-1300 text-center" *ngIf="!!featureTags && !featureTags['sf_cms_images']">
        <img class="imgRes" src="https://hudsonmilk.com/images/3/cms/invoice_logo.jpg" alt="logo">
        <h3>YOU CAN WHIP OUR CREAM,<br>BUT YOU CAN’T BEAT OUR MILK!</h3>
        <img src="https://hudsonmilk.com/images/3/cms/hr-line.svg" alt="design">
        <div class="getSt"><a href="javascript:void(0)" routerLink="/sign-in" class="btnSqRed">GET STARTED</a></div>
    </div> 
    <div class="max-1300 text-center" *ngIf="!!featureTags && featureTags['sf_cms_images']">
        <img class="imgRes" src="assets/hudson/files/images/3/content-images/invoice_logo.jpg" alt="logo">
        <h3>YOU CAN WHIP OUR CREAM,<br>BUT YOU CAN’T BEAT OUR MILK!</h3>
        <img src="assets/hudson/files/images/3/content-images/hr-line.svg" alt="design">
        <div class="getSt"><a href="javascript:void(0)" routerLink="/sign-in" class="btnSqRed">GET STARTED</a></div>
    </div> 
</section>